<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Tạo hợp đồng combo bán hàng</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="$router.back()">Hủy</button>
        <button class="btn btn-success btn-primary ml-2" @click="createContract">
          Tạo & chuyển đã ký
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 row">
        <ValidationObserver class="w-100" ref="formAdd">
          <form class="col-md-6" @submit.prevent="createContract">
            <div class="merchant-detail-box">
              <div class="merchant-header">
                <span class="merchant-name">Thông tin hợp đồng</span>
              </div>

              <ValidationProvider rules="required" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã hợp đồng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="dataInsert.contractCode"
                      type="text"
                      class="form-control"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="signDate" name="Ngày ký">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày ký<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model="dataInsert.signDate" type="date" class="form-control" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="comboPackage" name="Gói combo">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Gói combo<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="dataInsert.comboPackage"
                      :options="optionCombo"
                      :disabled="optionCombo?.length === 0"
                      placeholder="Chọn combo"
                    >
                    </Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="usernames" name="Các username">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Các username<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model="dataInsert.usernames" class="form-control" rows="3" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="supportTeam" name="Đối tác tài trợ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tác tài trợ<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <!-- <input v-model="dataInsert.supportTeam" type="text" class="form-control"> -->
                    <Select2
                      v-model="dataInsert.supportTeam"
                      :options="optionAgent"
                      @select="getComboCode"
                      :settings="searchAgent"
                      placeholder="Tìm kiếm cộng tác viện"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <div class="form-group row">
                <label for="" class="col-sm-4 col-form-label">Mã yêu cầu</label>
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.requestCode" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-4 col-form-label">Mã giới thiệu</label>
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.inviteCode" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-4 col-form-label">Email người giới thiệu</label>
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.inviterEmail" type="text" class="form-control" />
                </div>
              </div>
            </div>

            <div class="form-group row mt-4 mb-2 ml-2">
              <h3 class="mt-1">Thông tin Merchant</h3>
              <button type="button" class="btn btn-primary ml-3" @click="openMerchantModal">
                {{ selectedMerchant ? 'Thay đổi merchant' : 'Tìm merchant' }}
              </button>

              <!-- <button type="button" class="btn btn-success ml-2" @click="addNewMerchant">
                Thêm mới MC
              </button> -->
              <button
                v-if="selectedMerchant"
                type="button"
                class="btn btn-danger ml-2"
                @click="clearMerchant"
              >
                Xóa
              </button>
            </div>
            <div>
              <!-- Thêm vào sau phần hiển thị thông tin merchant đã chọn -->
              <div v-if="dataMerchant" class="form-group row">
                <div class="col-sm-12">
                  <div class="merchant-detail-box">
                    <div class="merchant-header">
                      <span class="merchant-name"
                        >Merchant: {{ selectedMerchant?.customerName }}</span
                      >
                    </div>

                    <div class="merchant-info">
                      <div class="info-row">
                        <label class="info-label">Tên cửa hàng</label>
                        <input
                          v-model="dataMerchant.merchantName"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Hình thức định danh</label>
                        <Select2
                          v-model="dataMerchant.accIdType"
                          :options="optionAccIdType"
                          placeholder="Chọn hình thức"
                          class="info-input"
                        />

                        <!-- <input v-model="dataMerchant.accIdType" type="text" class="form-control info-input" /> -->
                      </div>
                      <div class="info-row" v-if="dataMerchant.accIdType === 'EMAIL'">
                        <label class="info-label">Email</label>
                        <input
                          v-model="dataMerchant.email"
                          type="email"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Số điện thoại</label>
                        <input
                          v-model="dataMerchant.mobile"
                          type="tel"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Ngày sinh</label>
                        <input
                          v-model="dataMerchant.birthDay"
                          type="date"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Giới tính</label>
                        <Select2
                          v-model="dataMerchant.gender"
                          :options="genderOptions"
                          placeholder="Chọn giới tính"
                          class="info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Loại hình</label>
                        <Select2
                          v-model="dataMerchant.customerType"
                          :options="optionCustomerType"
                          placeholder="Chọn loại hình"
                          class="info-input"
                        />
                        <!-- <input v-model="dataMerchant.customerType" type="text" class="form-control info-input" /> -->
                      </div>
                      <div class="info-row">
                        <label class="info-label">Tỉnh thành</label>

                        <Select2
                          v-model="dataMerchant.cityCode"
                          :options="dataProvince"
                          placeholder="Chọn tỉnh thành"
                          @select="getNameProvince($event)"
                          class="info-input"
                        />
                        <!-- <input v-model="dataMerchant.city" type="text" class="form-control info-input" /> -->
                      </div>
                      <div class="info-row">
                        <label class="info-label">Quận huyện</label>
                        <!-- <input v-model="dataMerchant.district" type="text" class="form-control info-input" /> -->
                        <Select2
                          v-model="dataMerchant.districtCode"
                          :options="dataDistrict"
                          placeholder="Chọn quận huyện"
                          @select="getNameDistrict($event)"
                          class="info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Xã phường</label>
                        <!-- <input v-model="dataMerchant.district" type="text" class="form-control info-input" /> -->
                        <Select2
                          v-model="dataMerchant.wardCode"
                          :options="wardOption"
                          placeholder="Chọn xã phường"
                          @select="getNameWard($event)"
                          class="info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Địa chỉ</label>
                        <input
                          v-model="dataMerchant.address"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Ngành hàng</label>
                        <Select2
                          v-model="dataMerchant.mcc"
                          :options="businessFields"
                          @select="getNameMc($event)"
                          placeholder="Chọn ngành hàng"
                          class="info-input"
                        />
                        <!-- <input v-model="dataMerchant.mccName" type="text" class="form-control info-input" /> -->
                      </div>
                      <div class="info-row">
                        <label class="info-label">Số ĐKKD</label>
                        <input
                          v-model="dataMerchant.businessRegistrationNumber"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Thêm vào sau box merchant detail -->

              <!-- Box Thông tin nhận hóa đơn -->
              <div v-if="dataMerchant" class="form-group row">
                <div class="col-sm-12">
                  <div class="merchant-detail-box">
                    <div class="merchant-header">
                      <span class="merchant-name">Thông tin nhận hóa đơn</span>
                    </div>

                    <div class="merchant-info">
                      <div class="info-row">
                        <label class="info-label">Tên đơn vị nhận hóa đơn</label>
                        <input
                          v-model="dataMerchant.invoiceMcName"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Mã số thuế</label>
                        <input
                          v-model="dataMerchant.invoiceMcBusinessNumber"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Địa chỉ</label>
                        <input
                          v-model="dataMerchant.invoiceMcAddress"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Tên người liên hệ</label>
                        <input
                          v-model="dataMerchant.invoiceMcContactName"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row" v-if="dataMerchant.accIdType === 'EMAIL'">
                        <label class="info-label">Email nhận TT</label>
                        <input
                          v-model="dataMerchant.invoiceMcEmail"
                          type="email"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Số ĐT nhận TT</label>
                        <input
                          v-model="dataMerchant.invoiceMcMobile"
                          type="tel"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Chức vụ</label>
                        <input
                          v-model="dataMerchant.invoiceMcContactPosition"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Box Thông tin người đại diện -->
              <div v-if="dataMerchant" class="form-group row">
                <div class="col-sm-12">
                  <div class="merchant-detail-box">
                    <div class="merchant-header">
                      <span class="merchant-name">Thông tin người đại diện</span>
                    </div>

                    <div class="merchant-info">
                      <div class="info-row">
                        <label class="info-label">Tên người đại diện</label>
                        <input
                          v-model="dataMerchant.customerName"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Chức vụ</label>
                        <input
                          v-model="dataMerchant.position"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row" v-if="dataMerchant.accIdType === 'EMAIL'">
                        <label class="info-label">Email</label>
                        <input
                          v-model="dataMerchant.authoriserEmail"
                          type="email"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Số điện thoại</label>
                        <input
                          v-model="dataMerchant.authoriserContactNumber"
                          type="tel"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">CCCD</label>
                        <input
                          v-model="dataMerchant.passport"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Nơi cấp</label>
                        <input
                          v-model="dataMerchant.placeOfIssue"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Địa chỉ thường trú</label>
                        <input
                          v-model="dataMerchant.authoriserAddress1"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Nơi ở hiện tại</label>
                        <input
                          v-model="dataMerchant.authoriserAddressPresent"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Box Cửa hàng - Chỉ phần cần sửa -->
              <!-- && dataMerchant.merchantBusinessAreas && dataMerchant.merchantBusinessAreas.length > 0 -->
              <div v-if="dataMerchant" class="form-group row">
                <div class="col-sm-12">
                  <div class="merchant-detail-box">
                    <div class="merchant-header">
                      <span class="merchant-name">Cửa hàng</span>
                      <button
                        v-if="!isCombo1279"
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        @click="addShop"
                      >
                        Thêm cửa hàng
                      </button>
                    </div>

                    <div class="shop-list">
                      <div v-for="(shop, index) in shopList" :key="index" class="shop-item">
                        <div class="shop-header">
                          <span class="shop-name">Cửa hàng {{ index + 1 }}</span>
                          <button
                            v-if="!isCombo1279"
                            type="button"
                            class="btn btn-link btn-sm text-danger p-0"
                            @click="removeShop(index)"
                          >
                            Xóa
                          </button>
                        </div>

                        <div class="merchant-info">
                          <div class="info-row">
                            <label class="info-label">Tên cửa hàng</label>
                            <input
                              v-model="shop.areaName"
                              type="text"
                              class="form-control info-input"
                            />
                          </div>
                          <div class="info-row">
                            <label class="info-label">Tỉnh thành</label>
                            <!-- <input v-model="shop.areaCity" type="text" class="form-control info-input" /> -->
                            <Select2
                              v-model="shop.areaCityCode"
                              :options="dataProvince"
                              placeholder="Chọn tỉnh thành"
                              @select="getNameProvinceStore($event, index)"
                              class="info-input"
                            />
                          </div>
                          <div class="info-row">
                            <label class="info-label">Quận huyện</label>
                            <!-- <input v-model="shop.areaDistrict" type="text" class="form-control info-input" /> -->
                            <Select2
                              v-model="shop.areaDistrictCode"
                              :options="dataDistrict"
                              placeholder="Chọn quận huyện"
                              @select="getNameDistrictStore($event, index)"
                              class="info-input"
                            />
                          </div>
                          <div class="info-row">
                            <label class="info-label">Xã phường</label>
                            <!-- <input v-model="dataMerchant.district" type="text" class="form-control info-input" /> -->
                            <Select2
                              v-model="shop.areaWardCode"
                              :options="shopWardOptions[index] || []"
                              placeholder="Chọn xã phường"
                              @select="getNameWardStore($event, index)"
                              class="info-input"
                            />
                          </div>
                          <div class="info-row">
                            <label class="info-label">Địa chỉ</label>
                            <input
                              v-model="shop.areaAddress"
                              type="text"
                              class="form-control info-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isCombo1279 && dataMerchant" class="form-group row">
                <div class="col-sm-12">
                  <div class="merchant-detail-box">
                    <div class="merchant-header">
                      <span class="merchant-name">Thông tin thiết bị</span>
                    </div>
                    <div class="merchant-info">
                      <div class="info-row">
                        <label class="info-label">Serial thiết bị</label>
                        <input
                          v-model.trim="deviceInfo.deviceComboSerial"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                      <div class="info-row">
                        <label class="info-label">Serial SIM</label>
                        <input
                          v-model.trim="deviceInfo.simComboSerial"
                          type="text"
                          class="form-control info-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- Cập nhật modal thông báo -->
    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <!-- Nếu có lỗi hoặc không thành công - chỉ hiển thị nút Đóng -->
        <b-button size="sm" variant="light" @click="close()" v-if="errorAdd || !isSuccess">
          Đóng
        </b-button>

        <!-- Nếu thành công - hiển thị 2 nút -->
        <template v-if="isSuccess && !errorAdd">
          <b-button size="sm" variant="success" @click="goToAddImages"> Bổ sung ảnh </b-button>
          <b-button size="sm" variant="light" @click="goToContractManager" class="ml-2">
            Bỏ qua
          </b-button>
        </template>
      </template>
    </b-modal>

    <!-- Modal xác nhận tạo -->
    <b-modal id="modal-scoped" v-model="addModal">
      <template #modal-header="{ close }">
        <h5>Tạo hợp đồng combo bán hàng</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">
          Bạn chắc chắn muốn tạo hợp đồng combo này và chuyển sang trạng thái đã ký ?
        </h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="confirmAdd"> Xác nhận </b-button>
      </template>
    </b-modal>

    <!-- Modal xác nhận hủy -->
    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ tạo hợp đồng combo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>

    <!-- Component chọn merchant -->
    <SelectMerchant
      :dialogId="'select-merchant-dialog'"
      @selectMerchant="onSelectMerchant"
      @addNewMerchant="addNewMerchant"
    />
  </div>
</template>

<script>
  import SelectMerchant from '@/components/SelectMerchantCombo.vue'
  // import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import { MerchantService } from '@/services/merchant.service'
  import { AgentService } from '@/services/agent.service'
  import { CommonService } from '@/services/common.service'

  export default {
    components: { SelectMerchant },
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        isNewMerchant: false,
        contractId: null, // ID hợp đồng sau khi tạo thành công
        isSuccess: false, // Flag để xác định hiển thị nút nào
        shopList: [],
        dataCombo: [],
        businessFields: [],
        dataInsert: {
          contractCode: '',
          signDate: '',
          comboPackage: '',
          usernames: '',
          supportTeam: '',
          requestCode: '',
          merchantId: '', // Thêm merchantId
        },
        dataProvince: [],
        dataMerchant: null,
        msgNoti: '',
        iconNoti: '',
        showModal: false,
        isPartnerCode: '',
        optionAgent: [],
        optionCustomerType: [
          {
            id: 'INDIVIDUAL',
            text: 'Cá nhân',
          },
          {
            id: 'HOUSEHOLD',
            text: 'Hộ kinh doanh',
          },
          {
            id: 'COMPANY',
            text: 'Doanh nghiệp',
          },
        ],
        optionAccIdType: [
          {
            id: 'MOBILE',
            text: 'Mobile',
          },
          {
            id: 'EMAIL',
            text: 'Email',
          },
        ],
        optionCombo: [],
        dataDistrict: [],
        errorAdd: false,
        addModal: false,
        cancelModal: false,
        loading: false,
        selectedMerchant: null, // Thông tin merchant đã chọn
        dataConfigRegion: [], // Danh sách vùng để hiển thị,
        searchAgent: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                AgentService.getListAgent({
                  name: keySearch,
                  page: 1,
                  limit: 10,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item?.agentId,
                            text: item.name || '',
                            code: item?.agentGroupCode,
                          }
                        }) || [],
                    })
                    // this.agentInfo.listSoft = res.data
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        wardOption: [],
        shopWardOptions: {},
        partnerCode: '',
        genderOptions: [
          {
            id: 'MALE',
            text: 'Nam',
          },
          {
            id: 'FEMALE',
            text: 'Nữ',
          },
        ],
        deviceInfo: {
          deviceComboSerial: '',
          simComboSerial: '',
        },
      }
    },
    created() {
      this.loadComboPackages()
      this.getRegions()
      this.getProvince()
      this.getDistictByCode()
      this.getConfigSystem()
      if (this.$route.query.agentId && this.$route.query.agentName) {
        this.optionAgent = [
          {
            id: this.$route.query.agentId,
            text: this.$route.query.agentName,
          },
        ]
        this.dataInsert.supportTeam = this.$route.query.agentId
      }
      if (this.$route.query.code) {
        this.dataInsert.requestCode = this.$route.query.code
        this.dataInsert.contractCode = this.$route.query.code
      }
      if (this.$route.query.partnerCode) {
        this.partnerCode = this.$route.query.partnerCode
      }
      if (this.$route.query.merchantName) {
        this.addNewMerchant({
          merchantName: this.$route.query.merchantName,
          businessRegistrationNumber: this.$route.query.businessRegistrationNumber,
          merchantAddress: this.$route.query.merchantAddress,
          representativeName: this.$route.query.representativeName,
          representativeEmail: this.$route.query.representativeEmail,
          representativeMobile: this.$route.query.representativeMobile,
          identityNumber: this.$route.query.identityNumber,
        })
        this.dataMerchant.customerType = 'HOUSEHOLD'
        this.dataMerchant.accIdType = 'EMAIL'
        this.dataMerchant.position = 'Chủ hộ'
        const shop = this.createEmptyShop()
        shop.areaName = this.$route.query.merchantName
        shop.areaAddress = this.$route.query.merchantAddress
        this.shopList = [shop]
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      isCombo1279() {
        return this.dataInsert.comboPackage === 'COMBOSELLTK_1279'
      },
    },
    watch: {
      'dataInsert.comboPackage'(newVal) {
        if (newVal === 'COMBOSELLTK_1279') {
          if (this.shopList.length === 0) {
            this.shopList = [this.createEmptyShop()]
          } else if (this.shopList.length > 1) {
            this.shopList = [this.shopList[0]]
          }
          Object.keys(this.shopWardOptions).forEach(key => {
            if (Number(key) >= 1) {
              this.$delete(this.shopWardOptions, key)
            }
          })
        }
        if (newVal !== 'COMBOSELLTK_1279') {
          this.deviceInfo.deviceComboSerial = ''
          this.deviceInfo.simComboSerial = ''
        }
      },
    },
    methods: {
      createEmptyShop() {
        return {
          id: null,
          areaName: '',
          areaCity: '',
          areaDistrict: '',
          areaAddress: '',
          areaCityCode: '',
          areaDistrictCode: '',
          areaWard: '',
          areaWardCode: '',
        }
      },
      formatDateInput(value) {
        if (!value) {
          return ''
        }
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) {
          return ''
        }
        const month = `${date.getMonth() + 1}`.padStart(2, '0')
        const day = `${date.getDate()}`.padStart(2, '0')
        return `${date.getFullYear()}-${month}-${day}`
      },
      parseDateToTimestamp(value) {
        if (!value) {
          return null
        }
        const date = new Date(value)
        const time = date.getTime()
        return Number.isNaN(time) ? null : time
      },
      async getListWardForShop(cityCode, shopIndex) {
        try {
          const data = await StaffService.getWardList({
            cityCode: cityCode,
          })
          if (data?.length > 0) {
            // Lưu danh sách xã phường cho cửa hàng tương ứng
            this.$set(
              this.shopWardOptions,
              shopIndex,
              data?.map(e => ({
                id: e.code,
                text: e.name,
              }))
            )
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getListWard(event) {
        try {
          const data = await StaffService.getWardList({
            cityCode: event,
          })

          if (data?.length > 0) {
            this.wardOption =
              data?.map(e => ({
                id: e.code,
                text: e.name,
              })) || []
          }
        } catch (error) {
          console.log(error)
        }
      },
      getComboCode(item) {
        this.isPartnerCode = item.code
      },
      getNameProvince(item) {
        this.dataMerchant.city = item.text
        this.dataMerchant.ward = ''
        this.dataMerchant.wardCode = ''
        this.getListWard(item.id)
      },
      getNameDistrict(item) {
        this.dataMerchant.district = item.text
      },
      getNameWard(item) {
        this.dataMerchant.ward = item.text
      },
      getNameProvinceStore(item, shopIndex) {
        if (this.shopList[shopIndex]) {
          this.shopList[shopIndex].areaCity = item.text
          this.shopList[shopIndex].areaWard = ''
          this.shopList[shopIndex].areaWardCode = ''
          this.getListWardForShop(item.id, shopIndex)
        }
      },
      getNameMc(item) {
        this.dataMerchant.mccName = item.text
      },

      getNameDistrictStore(item, shopIndex) {
        if (this.shopList[shopIndex]) {
          this.shopList[shopIndex].areaDistrict = item.text
        }
      },
      getNameWardStore(item, shopIndex) {
        if (this.shopList[shopIndex]) {
          this.shopList[shopIndex].areaWard = item.text
        }
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data
              this.businessFields =
                config.businessFields.map(e => ({ id: e.code, text: e.name })) || []
            }
          })
          .catch(error => console.log(error))
      },
      async getDistictByCode() {
        try {
          this.dataDistrict = []
          const data = await StaffService.getDistictByCode({})
          if (data.data.length > 0) {
            const dataDistrict = []
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistrict = dataDistrict
          }
        } catch (error) {}
      },

      async getProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            data.data.forEach(e => {
              this.dataProvince.push({
                id: e.code,
                text: e.name,
              })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      addNewMerchant(data = {}) {
        this.isNewMerchant = true
        this.selectedMerchant = null
        this.dataInsert.merchantId = ''

        // Tạo object merchant rỗng
        this.dataMerchant = {
          merchantName: data?.merchantName || '',
          accIdType: '',
          email: data?.representativeEmail || '',
          mobile: data?.representativeMobile || '',
          customerType: '',
          city: '',
          cityCode: '',
          district: '',
          districtCode: '',
          ward: '',
          wardCode: '',
          address: data?.merchantAddress || '',
          mccName: '',
          mcc: '',
          businessRegistrationNumber: data?.businessRegistrationNumber || '',
          invoiceMcBusinessNumber: '',
          // Thông tin nhận hóa đơn
          invoiceMcName: '',
          invoiceMcAddress: '',
          invoiceMcContactName: '',
          invoiceMcEmail: '',
          invoiceMcMobile: '',
          invoiceMcContactPosition: '',
          // Thông tin người đại diện
          customerName: data?.representativeName || '',
          position: '',
          authoriserEmail: data?.representativeEmail || '',
          authoriserContactNumber: data?.representativeMobile || '',
          passport: data?.identityNumber || '',
          placeOfIssue: 'CỤC CẢNH SÁT QUẢN LÝ HÀNH CHÍNH VỀ TRẬT TỰ XÃ HỘI',
          authoriserAddress1: '',
          authoriserAddressPresent: '',
          birthDay: '',
          gender: '',
        }

        // Khởi tạo danh sách cửa hàng với 1 cửa hàng rỗng
        this.shopList = [this.createEmptyShop()]
      },
      addShop() {
        if (this.isCombo1279) {
          return
        }
        this.shopList.push(this.createEmptyShop())
      },

      removeShop(index) {
        if (this.isCombo1279) {
          return
        }
        this.shopList.splice(index, 1)
      },

      // Cập nhật method onSelectMerchant
      async onSelectMerchant(merchant) {
        this.selectedMerchant = merchant
        this.dataInsert.merchantId = merchant.id
        this.isNewMerchant = false // Reset flag khi chọn merchant có sẵn
        // Gọi API lấy chi tiết merchant
        if (merchant.customerId) {
          await this.fetchMerchantDetail(merchant.customerId)
        }
      },

      // Cập nhật method clearMerchant
      clearMerchant() {
        this.selectedMerchant = null
        this.dataInsert.merchantId = ''
        this.dataMerchant = null
        this.isNewMerchant = false // Reset flag
        this.shopList = this.isCombo1279 ? [this.createEmptyShop()] : [] // Reset danh sách cửa hàng
        this.shopWardOptions = {}
      },
      async fetchMerchantDetail(customerId) {
        try {
          this.loading = true
          const data = await MerchantService.merchantDetail({
            customerId: customerId,
          })
          if (data.success) {
            this.dataMerchant = data.data
            this.shopWardOptions = {}
            if (!data.data.placeOfIssue)
              this.dataMerchant.placeOfIssue = 'CỤC CẢNH SÁT QUẢN LÝ HÀNH CHÍNH VỀ TRẬT TỰ XÃ HỘI'
            if (!Object.prototype.hasOwnProperty.call(this.dataMerchant, 'birthDay')) {
              this.$set(this.dataMerchant, 'birthDay', '')
            }
            if (!Object.prototype.hasOwnProperty.call(this.dataMerchant, 'gender')) {
              this.$set(this.dataMerchant, 'gender', '')
            }
            this.dataMerchant.birthDay = this.formatDateInput(this.dataMerchant.birthDay)
            this.dataMerchant.gender = this.dataMerchant.gender || ''
            if (
              this.dataMerchant.merchantBusinessAreas &&
              this.dataMerchant.merchantBusinessAreas.length > 0
            ) {
              this.shopList = this.dataMerchant.merchantBusinessAreas.map(area => ({
                id: area.id,
                areaName: area.areaName,
                areaCity: area.areaCity,
                areaDistrict: area.areaDistrict,
                areaAddress: area.areaAddress,
                areaCityCode: area.areaCityCode,
                areaDistrictCode: area.areaDistrictCode,
                areaWardCode: area.areaWardCode, // Thêm wardCode
                areaWard: area.areaWard, // Thêm ward
              }))
              await this.getListWard(data.data?.cityCode || '')

              // Load xã phường cho từng cửa hàng có districtCode
              this.shopList.forEach((shop, index) => {
                if (shop.areaCityCode) {
                  this.getListWardForShop(shop.areaCityCode, index)
                }
              })
              if (this.isCombo1279 && this.shopList.length > 1) {
                this.shopList = [this.shopList[0]]
                Object.keys(this.shopWardOptions).forEach(key => {
                  if (Number(key) >= 1) {
                    this.$delete(this.shopWardOptions, key)
                  }
                })
              }
            } else {
              this.shopList = [this.createEmptyShop()]
            }
          }
        } catch (error) {
          console.log('Lỗi khi lấy chi tiết merchant:', error)
        } finally {
          this.loading = false
        }
      },
      // Mở modal chọn merchant
      openMerchantModal() {
        this.$bvModal.show('select-merchant-dialog')
      },

      // Lấy danh sách vùng
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataConfigRegion = data.data.map(e => ({
              id: e.id,
              text: e.name,
            }))
          }
        } catch (error) {
          console.log('Lỗi khi lấy danh sách vùng:', error)
        }
      },

      // Tạo hợp đồng combo
      async createContract() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }

        // Kiểm tra đã chọn merchant chưa
        if (!this.selectedMerchant && !this.isNewMerchant) {
          this.showModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Vui lòng chọn merchant'
          this.errorAdd = true
          return
        }

        this.addModal = true
      },

      async confirmAdd() {
        this.addModal = false
        try {
          this.loading = true

          // Chuẩn bị dữ liệu merchant để gửi API
          let merchantData = null

          if (this.dataMerchant) {
            merchantData = {
              merchantName: this.dataMerchant.merchantName,
              accIdType: this.dataMerchant.accIdType,
              email: this.dataMerchant.email,
              mobile: this.dataMerchant.mobile,
              customerType: this.dataMerchant.customerType,
              city: this.dataMerchant.city,
              cityCode: this.dataMerchant.cityCode,
              district: this.dataMerchant.district,
              districtCode: this.dataMerchant.districtCode,
              ward: this.dataMerchant.ward,
              wardCode: this.dataMerchant.wardCode,
              address: this.dataMerchant.address,
              mcc: this.dataMerchant.mcc,
              mccName: this.dataMerchant.mccName,
              businessRegistrationNumber: this.dataMerchant.businessRegistrationNumber || '',

              // Thông tin nhận hóa đơn
              invoiceMcName: this.dataMerchant.invoiceMcName,
              invoiceMcBusinessNumber: this.dataMerchant.invoiceMcBusinessNumber,
              invoiceMcAddress: this.dataMerchant.invoiceMcAddress,
              invoiceMcContactName: this.dataMerchant.invoiceMcContactName,
              invoiceMcEmail: this.dataMerchant.invoiceMcEmail,
              invoiceMcMobile: this.dataMerchant.invoiceMcMobile,
              invoiceMcContactPosition: this.dataMerchant.invoiceMcContactPosition,

              // Thông tin người đại diện
              customerName: this.dataMerchant.customerName,
              position: this.dataMerchant.position,
              authoriserEmail: this.dataMerchant.authoriserEmail,
              authoriserContactNumber: this.dataMerchant.authoriserContactNumber,
              passport: this.dataMerchant.passport,
              placeOfIssue: this.dataMerchant.placeOfIssue,
              authoriserAddress1: this.dataMerchant.authoriserAddress1,
              authoriserAddressPresent: this.dataMerchant.authoriserAddressPresent,
              birthDay: this.parseDateToTimestamp(this.dataMerchant.birthDay),
              gender: this.dataMerchant.gender || null,

              // Cửa hàng
              merchantBusinessAreas: this.shopList.map(shop => ({
                id: shop.id || undefined,
                areaName: shop.areaName,
                areaCityCode: shop.areaCityCode,
                areaCity: shop.areaCity,
                areaDistrict: shop.areaDistrict,
                areaDistrictCode: shop.areaDistrictCode,
                areaAddress: shop.areaAddress,
                areaWard: shop.areaWard, // Thêm ward
                areaWardCode: shop.areaWardCode, // Thêm wardCode
                isChoose: true,
              })),

              // Thông tin người thao tác
              userId: this.dataUser.userId,
              userName: this.dataUser.username,
              companyCode: this.dataUser.companyCode,

              // Thông tin mặc định
              servicePackCode: 'SELL',
              businessFieldAmount: 1000000,
              suggestServiceType: ['COMBOSELL'],
              listService: ['COMBOSELL'],
              score: 0,
              brand: this.dataMerchant.merchantName,
              brandOwnerType: 'MC_OWNER',
              enableReceived: false,
            }
            let merchantResult = null
            // Chỉ gửi customerId nếu có (update merchant), không gửi nếu tạo mới
            if (this.selectedMerchant?.customerId) {
              merchantData.customerId = this.selectedMerchant.customerId
              merchantResult = await MerchantService.createOrUpdateMerchant(merchantData)
            } else {
              merchantResult = await MerchantService.createNewMerchant(merchantData)
            }
            // Gọi API tạo/cập nhật merchant
            if (merchantResult.code !== 1000) {
              throw new Error(merchantResult.message || 'Lỗi khi tạo/cập nhật merchant')
            }

            // Cập nhật merchantId từ kết quả API merchant
            this.dataInsert.merchantId =
              merchantResult.data.customerId || this.selectedMerchant?.customerId
          }

          // Lấy merchantId cuối cùng
          const finalMerchantId = this.dataInsert.merchantId

          // Tìm thông tin combo package đã chọn từ dataCombo
          const comboDetail = this.dataCombo.find(
            combo => combo.code === this.dataInsert.comboPackage
          )

          if (!comboDetail) {
            throw new Error('Không tìm thấy thông tin combo package')
          }

          // Lấy mảng giá đối tác từ comboDetail (nếu có)
          const partnerPriceArray = comboDetail?.partnerPrice || {}

          const newPrice = partnerPriceArray[this.isPartnerCode] || null

          // Chuẩn bị dữ liệu cho API tạo hợp đồng
          const contractData = {
            customerId: finalMerchantId,
            code: this.dataInsert.contractCode,
            typeCustomer: this.dataMerchant.customerType,
            // typeCustomer: this.getTypeCustomer(this.dataMerchant.customerType),
            effectiveFrom: new Date(this.dataInsert.signDate).getTime(),
            appendixPackages: {
              packageData: {
                number: 1,
                code: comboDetail.code,
                name: comboDetail.title,
                typeTime: comboDetail.typeTime,
                price: newPrice || comboDetail.amount,
                totalPrice: newPrice || comboDetail.amount,
                isDefaultFee: true,
              },
              number: 1,
              price: newPrice || comboDetail.amount,
              totalPrice: newPrice || comboDetail.amount,
              code: 'PLPM01',
            },
            userNameStr: this.dataInsert.usernames,
            sellPartnerId: this.dataInsert.supportTeam,
            reqSellCode: this.dataInsert.requestCode,
            inviteCode: this.dataInsert.inviteCode,
            inviterEmail: this.dataInsert.inviterEmail,
            deviceComboSerial: this.isCombo1279 ? this.deviceInfo.deviceComboSerial || null : null,
            simComboSerial: this.isCombo1279 ? this.deviceInfo.simComboSerial || null : null,
          }

          // Gọi API tạo hợp đồng combo
          const contractResult = await MerchantService.createComboContract(contractData)
          if (contractResult.success) {
            this.contractId = contractResult.data.id // Lưu id để điều hướng
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Đã tạo hợp đồng thành công. Bạn có muốn bổ sung ảnh?'
            this.errorAdd = false
            this.isSuccess = true // Flag để hiển thị 2 nút
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = contractResult.message
            this.errorAdd = true
            this.isSuccess = false
          }
        } catch (error) {
          console.log(error)
          this.showModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = error.message || 'Có lỗi xảy ra khi tạo hợp đồng combo'
          this.errorAdd = true
          this.isSuccess = false
        } finally {
          this.loading = false
        }
      },

      // Thêm các method mới để xử lý điều hướng
      goToAddImages() {
        this.showModal = false
        this.$router.push(`/sales-manager/detail-paper/${this.contractId}`)
      },

      goToContractManager() {
        this.showModal = false
        this.$router.push('/contract-manager')
      },
      backToList() {
        this.$router.push('/combo-contracts')
      },

      async loadComboPackages() {
        try {
          const data = await MerchantService.getPlaneServiceCommbo({
            page: 1,
            size: 1000,
          })
          if (data.code === 1000) {
            const groupService = data.data?.groupService?.find(e => e.group === 'SELL')
            const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
            const newData = comboService?.plan || []
            const defaultCombo = newData?.find(e => e.code === this.$route.query.packageCode)
            this.dataInsert.comboPackage = defaultCombo?.code || ''
            // const newData = plans?.filter(e => Array.isArray(e?.partnerEnable) && e.partnerEnable.includes(`${this.partnerCode}_DIGITAL`)) || [];
            this.dataCombo = newData || []
            this.optionCombo =
              newData?.map(e => {
                return {
                  id: e.code,
                  text: e.title,
                  partnerPrice: e.partnerPrice,
                }
              }) || []
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped>
  /* Thêm vào style scoped */
  .merchant-detail-box {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 16px;
    background-color: #fff;
    margin-top: 16px;
  }

  .merchant-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
  }

  .merchant-name {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }

  .merchant-info {
    display: grid;
    gap: 12px;
  }

  .info-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .info-label {
    width: 150px;
    flex-shrink: 0;
    font-weight: 500;
    color: #555;
    margin-bottom: 0;
  }

  .info-input {
    flex: 1;
    height: 38px;
  }

  .shop-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .shop-item {
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 12px;
    background-color: #f8f9fa;
  }

  .shop-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #dee2e6;
  }

  .shop-name {
    font-weight: 500;
    color: #495057;
  }
</style>
